import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiEndpoints } from '../common/config';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
  ) {}

  private loaded = false;

  /**
   * logout password
   */
  logout(): Observable<any> {
    return this.http.patch<any>(ApiEndpoints.authentication.logout, '');
  }
  getVersion(projectName: string): Observable<string> {
    return this.http.get(
      `${ApiEndpoints.about.getVersionSettings}/${projectName}`,
      { responseType: 'text' },
    );
  }

  getConfiguration(propertyName: string): Observable<string> {
    return this.http
      .get<any>(`${ApiEndpoints.configurations.GetByName}/${propertyName}`)
      .pipe(map((res: any) => res.Data.PropertyValue));
  }

  getGoogleAPIKey(): Observable<void> {
    return new Observable(observer => {
      if (this.loaded) {
        observer.next();
        observer.complete();
        return;
      }

      // Check if the script is already in the document to avoid duplicates
      if (document.querySelector('script[src*="maps.googleapis.com"]')) {
        this.loaded = true;
        observer.next();
        observer.complete();
        return;
      }

      let propertyName = 'GoogleAPIKeyNewClient';
      const subscription = this.http
        .get<any>(`${ApiEndpoints.configurations.GetByName}/${propertyName}`)
        .pipe(map((res: any) => res.Data.PropertyValue))
        .subscribe({
          next: (apiKey: string) => {
            const sanitizedApiKey = this.sanitizer.sanitize(
              SecurityContext.NONE,
              apiKey,
            );
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${sanitizedApiKey}&libraries=geometry,places,marker`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
              this.loaded = true;
              if (typeof google !== 'undefined') {
                observer.next();
                observer.complete();
              } else {
                observer.error(
                  new Error('Google Maps API not loaded properly.'),
                );
              }
            };

            script.onerror = error => {
              observer.error(error);
            };

            document.head.appendChild(script);
          },
          error: err => {
            observer.error(
              new Error('Failed to fetch API key: ' + err.message),
            );
          },
        });

      return () => subscription.unsubscribe();
    });
  }
}
